// extracted by mini-css-extract-plugin
export default {"todoname":"todo_todoname__5b0LQ","cancelBtn":"todo_cancelBtn__66Jx+","saveBtn":"todo_saveBtn__uprTj","deleteBtn":"todo_deleteBtn__XTbnp","checkBox":"todo_checkBox__E+5Pi"};